import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  riskDataService,
  assetDataService,
  assetSharedModelService
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-asset-type-dialog.controller';
import template from './edit-asset-type-dialog.html';
import validator, { name as validatorName } from './messages/unique-asset-type-name.validator.directive';
import nameMessagesTpl from './messages/name.messages.html';
import assignTopRiskTypesDialog from '../dialog.assignTopRiskTypesDialog';
import riskType from '../../../riskAdministration/riskType';
import notesMessagesTpl from './messages/asset-type.notes.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    assetType,
    assetCriticalities,
    assetDataTypes,
    assetDataUses
  }) {
    return {
      controller,
      controllerAs: 'editAssetTypeDialogVM',
      locals: {
        assetType,
        assetCriticalities,
        assetDataTypes,
        assetDataUses
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.assetAdministration.editAssetTypeDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  assetDataService,
  alerts,
  assignTopRiskTypesDialog,
  riskDataService,
  assetSharedModelService,
  riskType,
])
  .directive(validatorName, validator)
  .service('editAssetTypeDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('asset-type.name.messages.html', nameMessagesTpl);
    $templateCache.put('asset-type.notes.messages.html', notesMessagesTpl);
  })
  .name;

console.log('app.components.admin.assetAdministration.editAssetTypeDialog created');
